/**
 * withCouponTokens
 * HOC for wrapping the provided component with CouponTokensProvider
 */

import React from 'react'

import CouponTokensProvider from './coupon-tokens-provider'

export default function withCouponTokens (WrappedComponent) {
  return function CouponTokensProviderHOC(props) {
    return (
      <CouponTokensProvider>
        <WrappedComponent {...props} />
      </CouponTokensProvider>
    )
  }
}
